<template>
  <div class="dynamic-page">
    <h2 class="dynamic-page-title">動態</h2>
    <div class="page-content">
      <div class="tabs-wrap">
        <div class="tab-select">
          <button
            v-for="(t, i) in tabs"
            :key="'tab-' + t.key"
            class="one-select"
            :class="[showTab === i + 1 && 'selected-left', showTab === i && 'selected', showTab === i - 1 && 'selected-right']"
            @click="changeTab(i, t.key)"
          >
            {{ t.name }}
            <i class="has-new" v-if="$store.state.app.hasFeedFollow&&t.key==='following'"></i>
          </button>
          <div class="empty-block" :class="showTab === tabs.length - 1 && 'selected-right'" />
        </div>
        <FeedList
          v-for="(f, i) in tabs"
          v-show="i === showTab"
          :key="'list-' + f.key"
          class="list-wrap"
          :url="f.url"
          :isShow="i === showTab"
        >
          <template slot="empty">
            <div class="empty-wrap">
              <img class="empty-img" src="~@/assets/image/background/empty-dynamic.png">
              <span class="empty-text">哇～空空如也</span>
              <span class="empty-text">追蹤陪玩師看動態吧！</span>
            </div>
          </template>
        </FeedList>
      </div>
      <div class="page-right">
        <div v-if="userInfo" class="write-feed">
          <fps-avatar class="my-avatar" :src="userInfo.avatarUrl" />
          <span class="my-nickname">{{ userInfo.nickname }}</span>
          <div class="empty" />
          <fps-icon class="upload-btn" type="camera" size="28" @click.native="showLoadApp = true" />
        </div>
        <div class="recommend-wrap">
          <div class="recommend-title">
            <div class="recommend-tabs-wrap">
              <div class="one-tab active">熱門推薦</div>
            </div>
            <div class="get-more" @click="openRecommend">
              更多
              <fps-icon type="arrow-right" size="18" />
            </div>
          </div>
          <div v-if="gettingHot" class="loading-data">
            <i class="el-icon-loading"></i>
          </div>
          <div
            v-for="(r, i) in recommendList"
            :key="'recommend-' + i + '-' + r.userUuid"
            :class="['one-recommend', 'recommend-' + (i+1)]"
          >
            <div class="no">{{ i + 1 }}</div>
            <fps-avatar class="recommend-url pointer" :src="r.avatarUrl" @click.native="openDetail(r)" />
            <div class="recommend-nickname">{{ r.nickname }}</div>
            <button v-if="!userInfo || userInfo.uuid !== r.userUuid" class="reace-btn" :class="r.followStatus === 'Follow' && 'is-reace'" @click="reaceIt(r, i)">
              <i v-show="r.loading" class="el-icon-loading"></i>
              <span v-show="!r.loading && r.followStatus === 'Unfollow'">追蹤</span>
              <span v-show="!r.loading && r.followStatus === 'Follow'">取消追蹤</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showLoadApp"
      custom-class="dialog-clear-style"
      width="880px"
      append-to-body
    >
      <div class="load-app-dialog">
        <img src="~@/assets/image/pics/download-qr-code.png" />
        <span>網頁端暫不支持發布，請使用nicee app發布動態</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FeedList from '../user-feed/feed-list'
import { followUser } from '@/api'
export default {
  components: {
    FeedList,
  },
  data() {
    return {
      showTab: 0,
      showLoadApp: false,
      recommendList: [],
      gettingHot: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    tabs() {
      const list = [
        {
          name: '推薦',
          url: '/moment/square/recommend',
          key: 'recommend',
        },
        {
          name: '最近',
          url: '/moment/square/latest',
          key: 'lately',
        },
      ]
      if (this.userInfo) {
        list.push({
          name: '追蹤',
          url: '/moment/square/follow',
          key: 'following',
        })
      }
      return list
    }
  },
  created() {
    this.getRecommendList()
    this.startTime = Date.now()
    window.addEventListener('beforeunload', this.closePage)
  },
  beforeDestroy() {
    this.closePage()
  },
  methods: {
    changeTab(index, key) {
      this.showTab = index
      if(key === 'following') {
        this.$store.dispatch('app/updateFeedFollow', 0)
      }
    },
    openDetail(info) {
      this.$router.push({
        path: `/player-detail/${info.userUuid}`,
      })
    },
    closePage() {
      this.$adjust('web_moment_square_tp', {
        seconds: parseInt((Date.now() - this.startTime) / 1000)
      })
    },
    openRecommend() {
      this.$router.push({
        path: '/recommend-list'
      })
    },
    async reaceIt(f, i) {
      if (!this.userInfo) {
        this.$util.Login()
        return
      }
      if (f.loading) return
      f.loading = true
      this.recommendList.splice(i, 1, f)

      const followOptType = f.followStatus === 'Unfollow' ? 'Follow' : 'Unfollow'
      if (followOptType === 'Unfollow') {
        try {
          await this.$confirm({
            content: `確認要取消追蹤 <span class="font-bold">${ f.nickname }</span> 嗎？`,
            confirmButtonText: '取消追蹤',
            cancelButtonText: '再想想',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true
          })
        } catch (e) {
          f.loading = false
          this.recommendList.splice(i, 1, f)
          return
        }
      }
      followUser({
        followOptType,
        uuid: f.userUuid,
      }).then(() => {
        f.followStatus = followOptType
        f.loading = false
        // if (followOptType === 'Unfollow') {
        //   this.$store.dispatch('app/setSomeUserInfo', {
        //     following: this.userInfo.following - 1
        //   })
        // } else {
        //   this.$store.dispatch('app/setSomeUserInfo', {
        //     following: this.userInfo.following + 1
        //   })
        // }
        this.recommendList.splice(i, 1, f)
        this.$message.success('操作成功')
      }).catch(() => {
        f.loading = false
        this.recommendList.splice(i, 1, f)
        this.$message.error('操作失敗')
      })
    },
    getRecommendList() {
      this.$http.get('/rank/getHotRank')
        .then(({ data }) => {
          if (!data) return
          this.recommendList = data.slice(0, 5)
          this.gettingHot = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .dynamic-page {
    display: flex;
    flex-direction: column;
    .page-content {
      // flex: 1;
      @include flex(space-between, flex-start);
      padding-bottom: 72px;
    }
  }
  .tabs-wrap {
    width: 728px;
    border-radius: 4px;
    // height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #EFEFEF;
    // overflow: hidden;
    .tab-select {
      display: flex;
      height: 64px;
      $one-select-radius: 10px;
      .one-select {
        position: relative;
        background: rgba(0, 0, 0, 0.05);
        border-bottom: 1px solid #EFEFEF;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: $color-gray-3;
        padding: 0 24px;
        @include flex;
        &.selected {
          background: transparent;
          color: $color-gray-2;
          border: none;
        }
        &.selected-left {
          border-radius: 0 0 $one-select-radius 0;
          border-right: 1px solid #EFEFEF;
        }
        &.selected-right {
          border-radius: 0 0 0 $one-select-radius;
          border-left: 1px solid #EFEFEF;
        }
      }
      .empty-block {
        flex: 1;
        background: rgba(0, 0, 0, 0.05);
        border-bottom: 1px solid #EFEFEF;
        &.selected-right {
          border-radius: 0 0 0 $one-select-radius;
          border-left: 1px solid #EFEFEF;
        }
      }
    }
    // .list-wrap {
    //   flex: 1;
    //   overflow-y: auto;
    //   @include hideScrollBar(0, 0);
    // }
  }
  .page-right {
    width: 356px;
    .write-feed {
      @include flex;
      height: 80px;
      padding: 0 24px;
      @include whiteBox;
      margin-bottom: 16px;
      .my-avatar {
        width: 32px;
        height: 32px;
      }
      .my-nickname {
        max-width: 152px;
        @include ellipsis;
        font-weight: 600;
        font-size: 14px;
        margin-left: 8px;
        color: $color-gray-1;
      }
      .empty {
        flex: 1;
      }
      .upload-btn {
        color: $color-gray-2;
        cursor: pointer;
      }
    }
  }
  .recommend-wrap {
    padding: 12px 24px 24px;
    @include whiteBox;
    .recommend-title {
      height: 44px;
      margin-bottom: 20px;
      @include flex(space-between);
      .recommend-tabs-wrap {
        @include flex(flex-start);
      }
      .one-tab {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-1;
      }
      .active {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          width: 30px;
          height: 4px;
          border-radius: 4px;
          background: $color-yellow;
          left: 50%;
          top: 100%;
          transform: translate(-50%, 8px);
        }
      }
      .get-more {
        @include flex;
        color: $color-gray-3;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .loading-data {
      @include flex;
      font-size: 24px;
      height: 40px;
    }
    .one-recommend {
      @include flex;
      height: 56px;
      .no {
        width: 18px;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: $color-gray-3;
        font-weight: 500;
        font-style: italic;
      }
      &.recommend-1 .no {
        color: $color-yellow;
      }
      &.recommend-2 .no {
        color: #83CEFF;
      }
      &.recommend-3 .no {
        color: #FD9536;
      }
      .recommend-url {
        width: 32px;
        height: 32px;
        margin-left: 12px;
        margin-right: 8px;
      }
      .recommend-nickname {
        flex: 1;
        font-size: 12px;
        line-height: 16px;
        color: $color-gray-1;
        @include ellipsis;
      }
      .reace-btn {
        margin-left: 28px;
        width: 80px;
        height: 32px;
        border-radius: 50px;
        border: 1px solid $color-gray-1;
        font-size: 13px;
        line-height: 18px;
        color: $color-gray-1;
        &:hover {
          background: rgba(0, 122, 255, 0.1);
          border: 1px solid #007AFF;
          color: $color-link;
        }
        &.is-reace {
          border: 1px solid $color-split;
          color: $color-gray-2;
          &:hover {
            background: rgba(232, 234, 238, 0.3);
            border: 1px solid $color-split;
            color: $color-gray-2;
          }
        }
      }
    }
  }
  .load-app-dialog {
    height: 566px;
    @include flex;
    flex-direction: column;
    border-radius: 4px;
    background: #fff;
    img {
      width: 260px;
    }
    span {
      margin-top: 30px;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
    }
  }
  .empty-wrap {
    @include flex(flex-start, center, column);
    margin-top: 96px;
    padding-bottom: 182px;
    .empty-img {
      width: 142px;
    }
    .empty-text {
      font-size: 13px;
      line-height: 18px;
      /* or 138% */

      text-align: center;
      letter-spacing: -0.000319808px;

      color: #8C94AA;
    }
  }
  .has-new {
    display: block;
    position: absolute;
    top: 8px;
    right: 4px;
    width: 8px;
    height: 8px;
    background: #E63B37;
    border-radius: 50%;
  }
</style>
